<template>
    <modal id="skill-zone-modal"
           size="large"
           v-model="showModal"
           :title="generateModalTitle('Skill Zone')"
           @submit="submit"
           :loading="loading"
           :preloader="preloader"

    >
        <form :data-url='selectedUrl ? selectedUrl : apiUrl.SKILL_ZONE'
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submitData">
                    <app-form-group
                        :label="$t('title')"
                        type="text"
                        v-model="formData.title"
                        :placeholder="$placeholder('title')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'title')"
                    />
                    <app-form-group
                        :label="$t('description')"
                        type="text"
                        v-model="formData.description"
                        :placeholder="$placeholder('description')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'description')"
                    />
        </form>
    </modal>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {
    errorMessageInArray,
    formDataAssigner
} from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "SkillZoneCreateEdit",
    components: {},
    mixins: [FormHelperMixins, ModalMixin],
    comments: {},
    data() {
        return {
            errorMessageInArray,
            formData: {
                title: '',
                description: '',
            }
        };
    },
    computed: {
    },
    methods: {
        submit() {
            this.loading = true;
            let formData = {...this.formData}
            formData = formDataAssigner(new FormData, formData);
            let url = this.apiUrl.SKILL_ZONE;
            if (this.selectedUrl) {
                formData.append('_method', "PUT");
                url = this.selectedUrl;
            }
            axiosPost(url, formData).then(({data}) => {
                this.loading = false;
                $('#skill-zone-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'skill-zone-table');
            }).catch(({response}) => {
                this.loading = false;
                this.message = '';
                this.errors = response.data.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data.message || response.statusText);
                }
            });

        },
        afterSuccess({data}) {
            this.formData = {};
            $('#skill-zone-modal').modal('hide');
            this.toastAndReload(data.message, 'skill-zone-table')
            this.$emit('input', false);
        },
        afterError(response) {
            this.loading = false;
            this.errors = response.data.errors;
        },
    }
}
</script>
